const el = {
  pleaseEnterUsername: "Παρακαλώ εισάγετε όνομα χρήστη",
  cannotFriendYourself: "Δεν μπορείτε να στείλετε αίτημα φιλίας στον εαυτό σας.",
  friendRequestSent: "Το αίτημα φιλίας στάλθηκε!",
  failedToSendRequest: "Αποτυχία αποστολής αιτήματος",
  linkCopied: "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο!",
  backToInvites: "Επιστροφή στις προσκλήσεις",
  sendFriendRequestByUsername: "Αποστολή αιτήματος φιλίας με όνομα χρήστη",
  enterUsername: "Εισαγάγετε όνομα χρήστη",
  send: "Αποστολή",
  yourInviteQrCode: "Ο κωδικός QR της πρόσκλησής σας",
  inviteLink: "Σύνδεσμος πρόσκλησης",
  scanQrOrUseLink: "Σαρώστε αυτόν τον κωδικό QR ή χρησιμοποιήστε αυτόν τον σύνδεσμο για να στείλετε αίτημα φιλίας",
  copyInviteLink: "Αντιγραφή συνδέσμου πρόσκλησης",
  goToItem: "Μετάβαση στο στοιχείο",
  verificationEmailSent: "Το email επαλήθευσης στάλθηκε! Ελέγξτε τα εισερχόμενά σας.",
  verificationEmailFailed: "Αποτυχία αποστολής email επαλήθευσης. Παρακαλώ δοκιμάστε ξανά.",
  verifyYourEmail: "Επαληθεύστε το email σας",
  verifyEmailInstructions: "Παρακαλώ επαληθεύστε τη διεύθυνση email σας για να αποκτήσετε πρόσβαση στον λογαριασμό σας. Ελέγξτε τα εισερχόμενά σας για τον σύνδεσμο επαλήθευσης.",
  sending: "Αποστολή...",
  resendVerificationEmail: "Επαναποστολή email επαλήθευσης",
  login: "Σύνδεση",
  register: "Εγγραφή",
  home: "Αρχική",
  calendar: "Ημερολόγιο",
  friends: "Φίλοι",
  profile: "Προφίλ",
  logout: "Αποσύνδεση",
  loading: "Φόρτωση...",
  language: "Γλώσσα",
  calendarSelectPlaceSuggestion: "Παρακαλώ επιλέξτε ένα μέρος από τις προτάσεις ώστε να επισυναφθούν οι συντεταγμένες.",
  calendarSelectDateAndTime: "Παρακαλώ επιλέξτε ημερομηνία και ώρα.",
  calendarPositiveDuration: "Παρακαλώ εισάγετε θετική διάρκεια.",
  calendarFutureDateRequired: "Η ημερομηνία και ώρα του συμβάντος πρέπει να είναι στο μέλλον.",
  calendarCreateEventFailed: "Αποτυχία δημιουργίας συμβάντος. Παρακαλώ δοκιμάστε ξανά.",
  cancel: "Ακύρωση",
  createNewEvent: "Δημιουργία νέου συμβάντος",
  week: "Εβδομάδα",
  month: "Μήνας",
  eventTitle: "Τίτλος",
  date: "Ημερομηνία",
  time: "Ώρα",
  duration: "Διάρκεια",
  endsAt: "Λήγει στις",
  place: "Τοποθεσία",
  searchForPlace: "Αναζήτηση τοποθεσίας",
  placeSearchTip: "Συμβουλή: αρχίστε να πληκτρολογείτε και επιλέξτε ένα αποτέλεσμα για να επισυνάψετε συντεταγμένες.",
  description: "Περιγραφή",
  createEvent: "Δημιουργία συμβάντος",
  today: "Σήμερα",
  previousMonth: "Προηγούμενος μήνας",
  nextMonth: "Επόμενος μήνας",
  previous: "Προηγούμενο",
  next: "Επόμενο",
  mondayShort: "Δευ",
  tuesdayShort: "Τρι",
  wednesdayShort: "Τετ",
  thursdayShort: "Πεμ",
  fridayShort: "Παρ",
  saturdayShort: "Σαβ",
  sundayShort: "Κυρ",
  more: "Περισσότερα",
  mustRespondWillBeforeReposting: "Πρέπει να επιλέξετε «Θα παρευρεθώ» πριν από την αναδημοσίευση",
  event: "Συμβάν",
  backToCalendar: "Επιστροφή στο ημερολόγιο",
  addToGoogleCalendar: "Προσθήκη στο Google Calendar",
  when: "Πότε",
  where: "Πού",
  openLocationInGoogleMaps: "Άνοιγμα τοποθεσίας στους Χάρτες Google",
  hosts: "Διοργανωτές",
  yourResponse: "Η απάντησή σας",
  currentResponse: "Τρέχουσα απάντηση",
  response_will: "Θα παρευρεθώ",
  response_might: "Ίσως παρευρεθώ",
  response_wont: "Δεν θα παρευρεθώ",
  willRunIntoYou: "Θα περάσω να σε δω",
  mightDropBy: "Ίσως περάσω",
  wontCome: "Δεν θα έρθω",
  repostToMyFriends: "Αναδημοσίευση στους φίλους μου",
  responses: "Απαντήσεις",
  willAttend: "Θα παρευρεθώ",
  reposted: "Αναδημοσιεύτηκε",
  mightAttend: "Ίσως παρευρεθώ",
  cancelEvent: "Ακύρωση συμβάντος",
  cancellationEmailNoticeBefore: "Τα άτομα που έχουν απαντήσει",
  cancellationEmailNoticeAfter: "θα ειδοποιηθούν μέσω email για την ακύρωση του συμβάντος.",
  optionalCancellationMessage: "Προαιρετικό μήνυμα προς τους συμμετέχοντες (μέγιστο 1000 χαρακτήρες)",
  confirmCancelEvent: "Επιβεβαίωση ακύρωσης συμβάντος",
  clear: "Καθαρισμός",
  confirmCancellation: "Επιβεβαίωση ακύρωσης",
  confirmCancellationMessage: "Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτό το συμβάν; Οι επιβεβαιωμένοι συμμετέχοντες θα ειδοποιηθούν και το συμβάν θα αφαιρεθεί.",
  eventCancelledNotified: "Το συμβάν ακυρώθηκε. Έγινε ειδοποίηση σε",
  attendees: "συμμετέχοντες",
  failedToCancelEvent: "Αποτυχία ακύρωσης συμβάντος",
  back: "Πίσω",
  cancelled: "Ακυρώθηκε",
  ok: "OK",
  forgotPassword: "Ξεχάσατε τον κωδικό πρόσβασης;",
  email: "Email",
  passwordResetLinkSent: "Εάν ο λογαριασμός υπάρχει, στάλθηκε σύνδεσμος επαναφοράς κωδικού πρόσβασης.",
  passwordResetRequestFailed: "Αποτυχία αιτήματος επαναφοράς κωδικού πρόσβασης.",
  sendResetLink: "Αποστολή συνδέσμου επαναφοράς",
  addFriend: "Προσθήκη φίλου",
  incomingRequests: "Εισερχόμενα αιτήματα",
  accept: "Αποδοχή",
  deny: "Απόρριψη",
  myFriends: "Οι φίλοι μου",
  noFriendsYet: "Δεν έχετε ακόμη φίλους. Ξεκινήστε προσθέτοντας μερικούς!",
  seeProfile: "Προβολή προφίλ",
  noEventsToRespondTo: "Δεν υπάρχουν συμβάντα για απάντηση",
  allCaughtUp: "Ενημερωθήκατε για όλα. Επιστρέψτε αργότερα για νέα συμβάντα φίλων.",
  events: "Συμβάντα",
  unknown: "Άγνωστο",
  noDescriptionProvided: "Δεν δόθηκε περιγραφή.",
  will: "Θα παρευρεθώ",
  maybe: "Ίσως",
  wont: "Δεν θα παρευρεθώ",
  userNotFound: "Ο χρήστης δεν βρέθηκε",
  friendRequestSentSuccessfully: "Το αίτημα φιλίας στάλθηκε με επιτυχία!",
  friendInvitation: "Πρόσκληση φιλίας",
  sendFriendRequest: "Αποστολή αιτήματος φιλίας",
  loginToSendFriendRequest: "Παρακαλώ συνδεθείτε για να στείλετε αίτημα φιλίας",
  chooseLanguage: "Επιλέξτε γλώσσα",
  invalidCredentials: "Μη έγκυρα στοιχεία σύνδεσης. Παρακαλώ δοκιμάστε ξανά.",
  username: "Όνομα χρήστη",
  password: "Κωδικός πρόσβασης",
  forgotPasswordQuestion: "Ξεχάσατε τον κωδικό πρόσβασης;",
  dontHaveAccount: "Δεν έχετε λογαριασμό;",
  registerHere: "Εγγραφείτε εδώ",
  invalidProfilePhotoType: "Μη έγκυρος τύπος αρχείου. Παρακαλώ ανεβάστε εικόνα JPEG, PNG, GIF ή WebP.",
  invalidFileExtension: "Μη έγκυρη επέκταση αρχείου",
  allowedExtensions: "Επιτρεπόμενα",
  fileTooLarge: "Το αρχείο είναι πολύ μεγάλο",
  maximumFileSize: "Μέγιστο μέγεθος",
  profilePhotoRemoved: "Η φωτογραφία προφίλ αφαιρέθηκε.",
  failedToRemoveProfilePhoto: "Αποτυχία αφαίρεσης φωτογραφίας προφίλ",
  profileUpdatedSuccessfully: "Το προφίλ ενημερώθηκε επιτυχώς!",
  failedToUpdateProfile: "Αποτυχία ενημέρωσης προφίλ",
  privateEmailExplanation: "Μόνο εσείς μπορείτε να δείτε το email σας για αποφυγή ανεπιθύμητων μηνυμάτων εκτός πλατφόρμας",
  yourEmailIsPrivate: "Το email σας είναι ιδιωτικό.",
  profilePhoto: "Φωτογραφία προφίλ",
  removePhoto: "Αφαίρεση φωτογραφίας",
  firstName: "Όνομα",
  lastName: "Επώνυμο",
  tellPeopleAboutYourself: "Μιλήστε στους άλλους για εσάς",
  whereToContactMe: "Πού να επικοινωνήσουν μαζί μου",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Αποθήκευση",
  notSet: "Δεν έχει οριστεί",
  editProfile: "Επεξεργασία προφίλ",
  imageToCrop: "Εικόνα προς περικοπή",
  zoom: "Ζουμ",
  usePhoto: "Χρήση φωτογραφίας",
  name: "Όνομα",
  whereToContact: "Πού να επικοινωνήσουν",
  removeFriendship: "Κατάργηση φιλίας",
  confirmRemoveFriend: "Επιβεβαίωση κατάργησης φίλου",
  confirmRemoveFriendBefore: "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε τον",
  confirmRemoveFriendAfter: "από τους φίλους σας;",
  friendRemoved: "Ο φίλος αφαιρέθηκε.",
  failedToRemoveFriend: "Αποτυχία αφαίρεσης φίλου.",
  confirmRemove: "Επιβεβαίωση κατάργησης",
  error: "Σφάλμα",
  removed: "Αφαιρέθηκε",
  passwordsDoNotMatch: "Οι κωδικοί πρόσβασης δεν ταιριάζουν",
  registrationFailed: "Η εγγραφή απέτυχε. Παρακαλώ δοκιμάστε ξανά.",
  confirmPassword: "Επιβεβαίωση κωδικού πρόσβασης",
  alreadyHaveAccount: "Έχετε ήδη λογαριασμό;",
  loginHere: "Συνδεθείτε εδώ",
  passwordResetSuccessfully: "Ο κωδικός πρόσβασης επαναφέρθηκε επιτυχώς.",
  failedToResetPassword: "Αποτυχία επαναφοράς κωδικού πρόσβασης.",
  resetPassword: "Επαναφορά κωδικού πρόσβασης",
  newPassword: "Νέος κωδικός πρόσβασης",
  confirmNewPassword: "Επιβεβαίωση νέου κωδικού πρόσβασης",
  setNewPassword: "Ορισμός νέου κωδικού πρόσβασης",
  emailVerifiedSuccessfully: "Το email επαληθεύτηκε επιτυχώς!",
  emailVerificationFailed: "Η επαλήθευση απέτυχε. Ο σύνδεσμος μπορεί να είναι άκυρος ή να έχει λήξει.",
  verifying: "Γίνεται επαλήθευση...",
  verified: "Επαληθεύτηκε!",
  redirectingToHome: "Ανακατεύθυνση στην αρχική σελίδα...",
  verificationFailed: "Η επαλήθευση απέτυχε",
  goToHome: "Μετάβαση στην αρχική σελίδα",
  about: "Σχετικά",
  aboutConceptTitle: "Ιδέα",
  aboutCreatorIntroduction: "Γεια, είμαι ο Crypt0, αναρριχητής και δημιουργός του Run Into Me.",
  aboutCreatorStory: "Δημιούργησα τον ιστότοπο επειδή είμαι κοινωνικός και αφιέρωνα πολύ χρόνο στην οργάνωση συναντήσεων με άλλους αναρριχητές.",
  aboutPlanningProblem: "Ήθελα να ενημερώνω όλους ταυτόχρονα για το πότε και πού θα σκαρφάλωνα, χωρίς επίσημη πρόσκληση.",
  aboutDeveloperSolution: "Τότε θυμήθηκα ότι είμαι προγραμματιστής και μπορούσα να δημιουργήσω μόνος μου μια λύση.",
  aboutWelcome: "Καλώς ήρθατε στο Run Into Me, όπου ενημερώνετε τους φίλους σας για δραστηριότητες στις οποίες μπορούν να συμμετάσχουν χωρίς πίεση.",
  aboutCallToAction: "Δημοσιεύστε εδώ την επόμενη δραστηριότητα που είναι πιο διασκεδαστική μαζί!",
  aboutTutorialTitle: "Οδηγός",
  aboutCalendarCreateEvent: "Η οθόνη Ημερολογίου επιτρέπει και τη δημιουργία νέου συμβάντος.",
  aboutEventColorsIntroduction: "Τα χρώματα δείχνουν την κατάσταση συμμετοχής:",
  aboutColorGold: "Χρυσό",
  aboutColorGoldDescription: "Διοργανώνετε αυτό το συμβάν.",
  aboutColorGreen: "Πράσινο",
  aboutColorGreenDescription: "Θα συμμετάσχετε.",
  aboutColorOrange: "Πορτοκαλί",
  aboutColorOrangeDescription: "Απαντήσατε «ίσως».",
  aboutColorBlue: "Μπλε",
  aboutColorBlueDescription: "Δεν έχετε απαντήσει ακόμη.",
  aboutColorGray: "Γκρι",
  aboutColorGrayDescription: "Απορρίψατε την πρόσκληση.",
  aboutCalendarEventDetails: "Πατήστε ένα συμβάν για λεπτομέρειες και απάντηση.",
  aboutFriendPageTitle: "Σελίδα φίλων",
  aboutFriendPageDescription: "Εισαγάγετε όνομα χρήστη ή στείλτε σύνδεσμο / κωδικό QR.",
  aboutHomePageTitle: "Αρχική σελίδα",
  aboutHomePageDescription: "Δείτε τα προσεχή συμβάντα και δηλώστε συμμετοχή.",
  aboutRepostScreenTitle: "Οθόνη αναδημοσίευσης",
  aboutGoogleCalendarDescription: "Προσθέστε το συμβάν στο Google Calendar με αυτό το κουμπί.",
  aboutRepostDescription: "Μετά την επιβεβαίωση μπορείτε να το αναδημοσιεύσετε στους φίλους σας.",
};

export default el;